import { TakerQuoteBreakdownBlotter } from '../../../../containers/Trading/Markets/TakerQuoteBreakdown/TakerQuoteBreakdownBlotter';
import type { TakerQuoteBreakdownPanelConfig } from '../../../../types/LayoutConfig';
import { Panel } from '../../../Layout/Components/Panel';
import type { LayoutPanelProps } from '../../types';

export function TakerQuoteBreakdownPanel({ api, params }: LayoutPanelProps<TakerQuoteBreakdownPanelConfig>) {
  return (
    <Panel panelApi={api} data-testid="taker-quote-panel">
      <TakerQuoteBreakdownBlotter rfqID={params.rfqID} />
    </Panel>
  );
}
